module.exports = __webpack_public_path__ + "static/scale-model-of-egasse-braasch-house-in-pasadena-california-9f3cd7129e719a278fc54389be7cadf3.png";